<template>
    <div>
        <CFTitle title="22. Resurse materiale implicate"></CFTitle>
        <validation-observer #default="{ invalid }" ref="resurseMateriale">
            <span class="display-none">{{ invalid }}</span>
            <M3Warn v-if="addresses.length < 1" type="red-warn" text="Locațiile de implementare pot fi adăugate din pagina "><template v-slot:link><router-link to="/aplicatii/m3-sketch/proiectul-meu" style="margin-left: 10px; color: #ffffff; font-weight: 600">Proiectul meu</router-link></template></M3Warn>
            <div v-for="(address, key) in addresses" :key="key" class="materiale-table">
                <table class="padding-td">
                    <tbody>
                        <tr>
                            <td style="width: 17%"><p>Adresa</p></td>
                            <td>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="address.address"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 17%"><p>Extra info</p></td>
                            <td>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="address.info"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 17%"><p>Cod țară</p></td>
                            <td>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="address.country_code"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 17%"><p>Țară</p></td>
                            <td>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="address.country"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 17%"><p>Regiune</p></td>
                            <td>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="address.region"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 17%"><p>Județ</p></td>
                            <td>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="address.state"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 17%"><p>Localitate</p></td>
                            <td>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="address.city"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 17%"><p>Cod ZIP</p></td>
                            <td>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="address.zip_code"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width: 17%"><p>Pus la dispoziție de</p></td>
                            <td>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="address.added_by"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <thead>
                        <tr>
                            <th class="table-head blue-head" style="width: 24%"><p>Resursa</p></th>
                            <th class="table-head blue-head" style="width: 24%"><p>Cantitate</p></th>
                            <th class="table-head blue-head" style="width: 24%"><p>UM</p></th>
                            <th class="table-head blue-head" style="width: 24%"><p>Partener</p></th>
                            <th class="table-head blue-head" style="width: 3%"><p>Acțiuni</p></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(resource, key2) in address.resources" :key="key2">
                            <td style="width: 24%">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="resource.resource"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                            <td style="width: 24%">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="resource.quantity"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                            <td style="width: 24%">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="resource.um"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                            <td style="width: 24%">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="resource.partner"
                                        type="text"
                                        :readonly="completed"
                                        :state="errors.length > 0 ? false : null"
                                    >
                                    </b-form-input>
                                </validation-provider>
                            </td>
                            <td style="width: 3%; text-align: center;">
                                <b-icon-plus-circle-fill :id="'add'+key2" class="add-icon mr-2" @click="addResource(key); $el.focus()"></b-icon-plus-circle-fill>
                                <b-tooltip :target="'add'+key2" triggers="hover">Adaugă resursă</b-tooltip>
                                <b-icon-back :id="'duplicate'+key2" class="duplicate-icon" :class="key2 > 0 ? 'mr-2' : ''" @click="duplicateResource(resource, key)"></b-icon-back>
                                <b-tooltip :target="'duplicate'+key2" triggers="hover">Duplică resursa</b-tooltip>
                                <b-icon-x-circle-fill v-if="key2 > 0" :id="'delete'+key2" class="delete-icon" @click="removeResource(key, key2)"></b-icon-x-circle-fill>
                                <b-tooltip :target="'delete'+key2" triggers="hover">Șterge resursa</b-tooltip>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p v-if="key > 0" class="delete-button" @click="deleteAddress(key)">Șterge resursa materială <b-icon-x-circle-fill class="delete-icon ml-1"></b-icon-x-circle-fill></p>
            </div>
            <hr class="mt-5">
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                @change="sendForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </validation-observer>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BTable, BFormInput, BIconXCircleFill, BIconPlusCircleFill, BFormCheckbox, BIconBack, BTooltip } from 'bootstrap-vue'
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    export default {
        components: {
            CFTitle,
            M3Warn,
            BTable, BFormInput, BIconXCircleFill, BIconPlusCircleFill, BFormCheckbox, BIconBack, BTooltip,
            ValidationProvider, ValidationObserver
        },
        props: {
            data: {
                type: Object,
                default: null
            },
            m3GrantApplication: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                completed: false,
                addresses: [],
            }
        },
        computed: {
            finantareProgress() {
                return this.$store.getters['finantare/progress'];
            }
        },
        watch: {
            finantareProgress: {
                handler() {
                    if(this.finantareProgress.includes('Resurse materiale implicate'))
                        this.completed = true;
                },
                deep: true
            },
            data: {
                handler: function() {
                    this.getLocationData()
                },
                deep: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.resurse_materiale){
                        this.addresses = this.m3GrantApplication.resurse_materiale
                    }
                },
                deep: true
            },
        },
        mounted() {
            if(this.finantareProgress.includes('Resurse materiale implicate'))
                this.completed = true;
            if(this.m3GrantApplication && this.m3GrantApplication.resurse_materiale){
                this.addresses = this.m3GrantApplication.resurse_materiale
            } else {
                this.getLocationData()
            }
        },
        methods: {
            getLocationData() {
                if(this.data && this.data.m3_project && this.data.m3_project.location_address && this.data.m3_project.location_address.length > 0){
                    this.items = []
                    this.data.m3_project.location_address.forEach(location => {
                        this.addresses.push({
                            address: location.address,
                            info: '',
                            country_code: '40',
                            country: 'Romania',
                            region: location.region,
                            state: location.state,
                            city: location.city,
                            zip_code: '',
                            added_by: '',
                            resources: [{resource: '', quantity: '', um: '', partner: JSON.parse(localStorage.getItem('currentM3Company')).name}]
                        })
                    })
                }
            },
            addResource(key){
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.addresses[key].resources.push({resource: '', quantity: '', um: '', partner: JSON.parse(localStorage.getItem('currentM3Company')).name})
                }
            },
            duplicateResource(resource, key){
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.addresses[key].resources.push({resource: resource.resource, quantity: resource.quantity, um: resource.um, partner: resource.partner})
                }
            },
            removeResource(key, key2){
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                } else {
                    this.addresses[key].resources.splice(key2, 1)
                }
            },
            sendForm() {
                this.$refs.resurseMateriale.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        if(this.completed){
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {resurse_materiale: this.addresses})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$emit('savedData')
                                    this.$store.dispatch('finantare/addToProgress', 'Resurse materiale implicate')
                                })
                        }
                        else{
                            this.$store.dispatch('finantare/removeFromProgress', 'Resurse materiale implicate')
                        }
                    }
                })
            },
            deleteAddress(key) {
                if(this.completed){
                    this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                } else {
                    this.addresses.splice(key, 1)
                }
            }
        }
    }
</script>

<style scoped>
table, th, td {
    border: 1px solid #979696;
    width: 100%;
    height: 100%;
}
.padding-td tr td:first-child{
    padding: 10px;
}
.table-head p{
    font-size: 14px;
    text-align: center;
    font-weight: 700;
    text-transform: uppercase;
}
.table-head{
    padding: 10px;
    border: 1px solid #979696;
    border-bottom: 0;
    position: relative;
}
.blue-head{
    background: #bdd6ee;
}
.materiale-table{
    margin-top: 30px;
    position: relative;
}
.delete-icon{
    margin: auto 0;
    color: var(--dangerColor);
    cursor: pointer;
}
.add-icon{
    margin: auto 0;
    color: var(--succesColor);
    cursor: pointer;
}
.duplicate-icon{
    margin: auto 0;
    color: #bdd6ee;
    cursor: pointer;
}
table >>> input{
    font-size: 12px;
    border: none;
    background: #e9ecef;
    border-radius: 0;
    min-height: 39px;
}
table >>> input:read-only{
    background: #a1fff1;
}
.delete-button{
    font-size: 14px;
    float: right;
    margin-top: 5px;
    cursor: pointer;
}
</style>
